export default {
  undo: [],
  redo: [],
  hasUnsaveChanges: false,
}
